import { Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import HowItWorksImageVariant from 'artkive/components/PageSections/HowItWorks/HowItWorksImageVariant'
import theme from 'artkive/utils/theme'

import KeepsakeSection from './KeepsakeSection'

export const howItWorksStyles = ({ breakpoints }) => ({
  // Steps marked narrowTitle get the desktop frame's 183px title box, so "We Photograph & Design" breaks before the "&".
  narrowStepTitle: {
    [breakpoints.up('md')]: {
      maxWidth: 183,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
})

export const Section = withStyles(({ breakpoints }) => ({
  titleWrap: {
    [breakpoints.up('md')]: {
      marginBottom: 48,
    },
  },
}))(KeepsakeSection)

export const Title = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.down('sm')]: {
    maxWidth: 292,
    margin: '0 auto',
  },
}))

export const SubtitleWrapper = styled('div')({
  marginTop: 16,
})

export const Subtitle = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.down('sm')]: {
    color: theme.colors.grey[700],
    fontWeight: 500,
  },
}))

export const Steps = withStyles(({ breakpoints }) => ({
  gridWrapper: {
    [breakpoints.up('md')]: {
      flexWrap: 'nowrap',
      gap: 40,
    },
  },
  gridItem: {
    [breakpoints.up('md')]: {
      padding: 0,
    },
  },
  stepTitle: {
    height: 'auto',
    alignItems: 'flex-start',
  },
  howItWorksDescription: {
    [breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },
}))(HowItWorksImageVariant)
